import { useContext, useEffect, useState } from 'react';

import Axios from 'axios';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

import DashboardContext from '../../Context';
import Loader from '../layout/Loader';
import Pagination from './Pagination';
import SearchFrom from './SearchFrom';
import Tabelrowbody from './Tabelrowbody';
import PropTypes from 'prop-types';

import './tabel.css';
import ExcelExport from './ExcelExport';

/**
 * این کامپوننت برای نمایش جدول در صفحاتسایت است
 */
export default function Tabel({
  urldata,
  showform,
  handelShowForm,
  FormTabel,
  isget,
  itemname,
  arryactions,
  gatewayBaseUrl = null,
  hasNotSearchBar = false,
  messageRoute = ''
}) {
  const {
    sideBardata,
    authentication,
    urldashboard,
    accessPage,
    handelloding,
    dataFromTabel,
    handelerrors,
    setOffSearchLoding,
    searchLoading,
  } = useContext(DashboardContext);

  const { location } = useHistory();

  const [dataFech, setDataFech] = useState({});

  const [startpage, setStartpage] = useState(
    JSON.parse(sessionStorage.getItem('startpage')) || 1
  );

  const [pageSize, setPageSize] = useState(
    JSON.parse(sessionStorage.getItem('pageSize')) || 10
  );

  const [serch, setSerch] = useState(
    JSON.parse(sessionStorage.getItem('serch')) || ''
  );

  const [deleteitem, setDeleteitem] = useState(false);

  const [loader, setLoader] = useState(true);

  const [paidModal, setPaidModal] = useState(false);

  const [inputvalue, setInputvalue] = useState('');

  const datafeching = async (startpage, pageSize, serch) => {
    let formdata = {};
    if (itemname) {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        search: serch,
        [itemname]: JSON.parse(sessionStorage.getItem('workerId')),
      };
    } else {
      formdata = {
        page: parseInt(startpage),
        pageSize: parseInt(pageSize),
        search: serch,
        ...dataFromTabel,
      };
    }
    try {
      const res = await Axios.post(
        `${gatewayBaseUrl === null ? urldashboard : gatewayBaseUrl}${
          urldata ? urldata : messageRoute ? '/smsQuery' : location.pathname
        }/${isget ? isget : messageRoute ? messageRoute : 'get'}`,
        JSON.stringify(formdata),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await res.data;

      setDataFech(data);
      setOffSearchLoding();
      setLoader(false);
      handelloding(false);
    } catch (error) {
      handelerrors(error);
    }
  };

  useEffect(() => {
    // if (searchLoading)
    datafeching(startpage, pageSize, serch);

    return () => {};
  }, [
    startpage,
    pageSize,
    serch,
    deleteitem,
    location.pathname,
    dataFromTabel,
    paidModal,
    searchLoading,
  ]);

  //logic serch start
  const handelserchinput = (e) => {
    if (e.target.value) {
      setInputvalue(e.target.value);
    } else {
      setInputvalue('');
      sessionStorage.setItem('serch', JSON.stringify(''));
      setSerch('');
      sessionStorage.setItem('startpage', JSON.stringify(1));
      sessionStorage.setItem('Pagination', JSON.stringify([]));
      setStartpage(1);
    }
  };

  const handelserch = (e) => {
    e.preventDefault();

    if (inputvalue) {
      sessionStorage.setItem('serch', JSON.stringify(inputvalue));
      setSerch(inputvalue);
      setLoader(true);
      sessionStorage.setItem('startpage', JSON.stringify(1));
      sessionStorage.setItem('Pagination', JSON.stringify([]));
      setStartpage(1);
    }
  };
  //logic serch end

  const handeldeleteitem = () => setDeleteitem(!deleteitem);

  const handelModalepaid = () => setPaidModal(!paidModal);

  //logic Pagination start
  const handelpagenumber = (number) => {
    sessionStorage.setItem('startpage', JSON.stringify(number));
    setStartpage(number);
    setLoader(true);
  };

  const handelprevpage = () => {
    if (parseInt(dataFech.page) === 1) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(startpage - 1));
      setStartpage(startpage - 1);
      setLoader(true);
    }
  };

  const handelNextpage = () => {
    if (dataFech.page === dataFech.totalPage) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(startpage + 1));
      setStartpage(startpage + 1);
      setLoader(true);
    }
  };
  //logic Pagination end

  const arryrowpage = [10, 20, 50, 100, 500, 2000];
  const handelrowPage = (e) => {
    setPageSize(parseInt(e.target.value));
    sessionStorage.setItem(
      'pageSize',
      JSON.stringify(parseInt(e.target.value))
    );
    sessionStorage.setItem('startpage', JSON.stringify(1));
    sessionStorage.setItem('Pagination', JSON.stringify([]));

    setStartpage(1);
    setLoader(true);
  };

  const [accessStatus, setAccessStatus] = useState([]);

  useEffect(() => {
    setAccessStatus(accessPage?.length > 0 ? accessPage : arryactions);
    return () => {};
  }, []);

  return (
    <>
      {sideBardata.length > 0 ? (
        <>
          {!accessStatus.includes('Get') ? null : (
            <>
              {!hasNotSearchBar && (
                <Row className='mb-3 mt-3'>
                  <SearchFrom
                    handelserchinput={handelserchinput}
                    handelserch={handelserch}
                    defaultvalue={serch}
                  />

                  <Col
                    md={6}
                    sm={6}
                    xs={12}
                    className='d-flex  justify-content-end'
                  >
                    {showform && (
                      <button
                        className={
                          FormTabel
                            ? 'btn btn-danger ml-3'
                            : 'btn btn-success ml-3'
                        }
                        onClick={handelShowForm}
                      >
                        {FormTabel ? 'بستن فرم و پاک کردن' : 'جستجو پیشرفته'}
                      </button>
                    )}
                    <div className='mt-sm-0 mt-lg-0 mt-3'>
                      {dataFech.hasOwnProperty('data') && (
                        <ExcelExport
                          data={dataFech?.data}
                          headers={dataFech?.headers?.map((item) => item.label)}
                          filename={location.pathname?.slice(
                            1,
                            location.pathname.length
                          )}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              )}
              {!loader ? (
                dataFech?.data?.length > 0 ? (
                  <>
                    <div className='table-responsive tabeldata'>
                      <Table bordered hover className='tabeldata'>
                        <thead>
                          <tr>
                            <th>#</th>
                            {dataFech?.headers?.length > 10
                              ? dataFech?.headers
                                  ?.slice(0, 10)
                                  .map((item) =>
                                    item.name === 'id' ? (
                                      <th key={item.name}>ردیف</th>
                                    ) : item.name === 'customerId' ? null : (
                                      <th key={item.name}>{item.label}</th>
                                    )
                                  )
                              : dataFech?.headers?.map((item) =>
                                  item.name === 'id' ? (
                                    <th key={item.name}>ردیف</th>
                                  ) : item.name === 'customerId' ? null : (
                                    <th key={item.name}>{item.label}</th>
                                  )
                                )}
                          </tr>
                        </thead>
                        <tbody>
                          {dataFech?.data?.map((item, index) => (
                            <Tabelrowbody
                              arryheder={
                                dataFech?.headers?.length > 10
                                  ? dataFech.headers.slice(
                                      10,
                                      dataFech.headers.length
                                    )
                                  : []
                              }
                              page={startpage}
                              key={item.id}
                              item={item}
                              number={index}
                              handeldeleteitem={handeldeleteitem}
                              handelModalepaid={handelModalepaid}
                              arryactions={accessStatus}
                            />
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Row className='mt-3 mb-5'>
                      <Col
                        md={5}
                        sm={6}
                        xs={12}
                        className='d-flex align-items-baseline'
                      >
                        <Pagination
                          totalPage={dataFech?.totalPage}
                          page={dataFech?.page}
                          handelprevpage={handelprevpage}
                          handelNextpage={handelNextpage}
                          handelpagenumber={handelpagenumber}
                        />
                      </Col>
                      <Col
                        md={4}
                        sm={3}
                        xs={6}
                        className='d-flex align-items-end d-sm-block mt-sm-2'
                      >
                        <div className='d-flex ml-auto mr-sm-auto '>
                          <p>مجموع کل : </p>
                          <span className='mr-2'> {dataFech.totalRecord} </span>
                        </div>
                      </Col>
                      <Col
                        md={3}
                        sm={3}
                        xs={6}
                        className='mt-sm-0 mt-3 mt-md-0'
                      >
                        <div className='rowminger'>
                          <p className='text-nowrap'>تعداد ردیف :</p>
                          <Form.Control
                            size='sm'
                            as='select'
                            onChange={handelrowPage}
                          >
                            {arryrowpage?.map((item) => (
                              <option
                                key={item}
                                selected={item === pageSize ? true : false}
                                value={item}
                              >
                                {item}
                              </option>
                            ))}
                          </Form.Control>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ' چیزی یافت نشد :('
                )
              ) : (
                <Loader />
              )}
            </>
          )}
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}

Tabel.propTypes = {
  /**ادرس که برای دریافت داده می تواند باشد */
  urldata: PropTypes.string,
  /**باشد دکمه جستجوپیشرفته نمایش داده می شود */
  showform: PropTypes.bool,
  /**ارسال داده فرم جستجو پیشرفته */
  handelShowForm: PropTypes.func,
  /**باشد رنگ دکمه جستجوپیشرفته تغییر میکند */
  FormTabel: PropTypes.bool,
  /**اگر باشد بجای این که با گت باشد به نوع گفته شده ارسال می شود */
  isget: PropTypes.string,
  /**اگر باشد یک پارامتر بااین اسم به اداده برای سمت کاربر استفاده می شود */
  itemname: PropTypes.string,
  /**دسترسی های کاربر  */
  arryactions: PropTypes.array,
  /**وجود نداشتن سرچ بار  */
  hasNotSearchBar: PropTypes.bool,
};
